import { render } from "./basic-loading.vue?vue&type=template&id=cb3eebf6&lang=true"
import script from "./basic-loading.vue?vue&type=script&lang=js"
export * from "./basic-loading.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\domin\\Desktop\\FIles\\front\\jauris\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__